"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePriceOrProduct = updatePriceOrProduct;
async function updatePriceOrProduct(machineRepo, machineId, aisleCode, micronProductId, price) {
    return await machineRepo.updatePriceOrProduct(machineId, aisleCode, micronProductId, price);
}
